export default __webpack_public_path__ + "static/media/reims17.63d5afd2.jpg";